<script>
  import CustomInput from "./CustomInput.vue";
  import CurrencyMixin from "../mixins/CurrencyMixin";

  export default {
    extends: CustomInput,

    mixins: [CurrencyMixin]
  }
</script>



// WEBPACK FOOTER //
// resources/vue/components/CurrencyInput.vue